import {EFileExtensions} from 'shared/constants/file-extensions';
import { ERequestType } from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {ICryptoProSignedDoc, IFileHashInfo} from '../model/types';
import {ICryptoProFileInfo, IGetFileHashesArgs, ISendSignedFileArgs} from './types';

/**
 * Получение хэша файла
 */
export const fetchFileHash = async (params: {
    entityName: string | undefined;
    docId?: string;
    algorithmCode: number;
    attachId?: string;
}): Promise<string> => {
    const response = await performRequest({
        url: `documents/${params?.entityName}/get-content-hash-cryptopro`,
        params: {
            algorithmCode: params.algorithmCode,
            docId: params.docId,
            attachId: params.attachId,
        },
    });
    return response.data;
};

/**
 * Получение хэша файлов для массового подписания
 */
export const fetchFilesHashes = async ({
    entityName,
    algorithmCode,
    attachIds,
}: IGetFileHashesArgs): Promise<IFileHashInfo[]> => {
    const response = await performRequest({
        url: `documents/${entityName}/get-content-hash-cryptopro-all`,
        method: ERequestType.POST,
        data: {
            algorithmCode,
            attachIds,
        },
    });
    return response.data;
};

/**
 * Получение данных о файле
 */
export const fetchFileInfo = async (
    entityName: string | undefined,
    docId: string | undefined,
): Promise<ICryptoProFileInfo> => {
    const response = await performRequest<ICryptoProFileInfo>({
        url: `documents/${entityName}/get-content-param-cryptopro/${docId}`,
    });
    return response.data;
};

/**
 * Отправка подписанного файла на сохранение
 */
export const sendSignedFile = async ({
    signatureFile,
    fileName,
    docId,
    publishAllowed,
    entityName,
    selectedFileExtension = EFileExtensions.SIG,
}: ISendSignedFileArgs): Promise<void> => {
    const fileFormData = new FormData();

    fileFormData.set('signContent', signatureFile);
    fileFormData.set('fileName', `${fileName}${selectedFileExtension}`);
    // TODO: переписать на attachId т.к. бэк в БД все равно ищет именно attachId и его подписывает
    fileFormData.set('docId', `${docId}`);
    fileFormData.set('publishAllowed', `${publishAllowed}`);

    await performRequest({
        url: `documents/${entityName}/save-sign-cryptopro`,
        method: ERequestType.POST,
        data: fileFormData,
    });
};

/**
 * Получение подписанных документов
 */
export const fetchSignedDocs = async (documentIds: string[]): Promise<ICryptoProSignedDoc[]> => {
    const data = await performRequest<ICryptoProSignedDoc[]>({
        url: 'documents/rpc/search-signed-docs',
        method: ERequestType.POST,
        data: {ids: documentIds},
    });
    return data.data;
};

/**
 * Получение незашифрованного сообщения по id документа
 */
export const fetchUnencryptedMessage = async (params: {
    entityName: string | undefined;
    docId: string | undefined;
}): Promise<string> => {
    const {entityName, docId} = params;
    const data = await performRequest<string>({
        url: `documents/${entityName}/get-content-data-cryptopro/${docId}`,
    });
    return data.data;
};
